import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    icon: {
        width: ({ width }) => width,
        height: ({ height }) => height,
        backgroundColor: ({ color }) => color ?? theme.palette.common.darkGrey,
        maskImage: ({ src }) => `url(${src})`,
        WebkitMaskImage: ({ src }) => `url(${src})`,
        maskPosition: 'center',
        maskSize: 'contain',
        maskRepeat: 'no-repeat',
        display: 'inline-block',
        aspectRatio: ({ aspectRatio }) => aspectRatio,
    },
}));
const Icon = ({ src, color, description, width = 50, height = 50, aspectRatio }) => {
    const classes = useStyles({ src: src, color: color, width: width, height: height, aspectRatio: aspectRatio });

    return <span className={classes.icon} role="img" aria-label={description} />;
};

export default Icon;
